<template>
<div>
	<Form :label-width="100">
		<Row :gutter="10">
			<Col span="6">
				<FormItem label="参保人员">
					<Input v-model="params.insurantNameOrId" clearable @on-enter="search" placeholder="人员姓名/证件号码"></Input>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="保障状态">
					<Select v-model="params.insuranceStatus" placeholder="请选择保障状态" clearable >
						<Option value="UNDONE">未完成</Option>
						<Option value="YUSHOUJIAN">待生效</Option>
						<Option value="CHENGBAOJIAN">保障中</Option>
						<Option value="ZHONGZHIJIAN">已失效</Option>
						<Option value="EXCEPTION">异常</Option>
						<!-- <Option value="JUBAO">拒保</Option> -->
					</Select>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="结算状态">
					<Select v-model="params.endBillStatus" placeholder="请选择结算状态" clearable >
						<Option value="WAIT_DONE">待结算</Option>
						<Option value="WAIT_CONFIRM">结算待确认</Option>
						<Option value="OK_DONE">已结算</Option>
					</Select>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="参保公司">
					<Input v-model="params.companyName" clearable @on-enter="search" placeholder="参保公司名称"></Input>
				</FormItem>
			</Col>
		</Row>
		<Row :gutter="10">
			<Col span="6">
				<FormItem label="起保日期">
					<daterange @on-change="val=>{setDateRange(val,'effectiveDateStart')}" is-fulltime placeholder="请选择起保日期" ></daterange>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="终保日期">
					<daterange @on-change="val=>{setDateRange(val,'effectiveDateEnd')}" is-fulltime placeholder="请选择终保日期" ></daterange>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="导入时间">
					<daterange @on-change="val=>{setDateRange(val,'createTime')}" is-fulltime placeholder="请选择导入时间" ></daterange>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="操作人">
					<Input v-model="params.userNameOrId" clearable @on-enter="search" placeholder="请输入操作人姓名"></Input>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="是否续保">
					<Select v-model="params.isAutoRenew" placeholder="请选择续保状态" clearable >
						<Option value="0">否</Option>
						<Option value="1">是</Option>
					</Select>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="是否撤件">
					<Select v-model="params.isCancel" placeholder="请选择" clearable >
						<Option value="1">是</Option>
						<Option value="0">否</Option>
					</Select>
				</FormItem>
			</Col>
		</Row>
		<Row :gutter="10">
			<Col span="16">
				<Button type="success" @click="toImport(0)">导入参保人员</Button>
				<Button type="success" @click="toImport(1)">导入不再续保人员</Button>
				<!-- <Button type="success" @click="selectChange">不再续保</Button> -->
				<span class="tips" v-if="companyInfo.notOkSize">导入参保人员前，请先完善参保公司信息！</span>
			</Col>
			<Col span="8" class="right">
				<Button type="info" @click="search">搜索</Button>
				<Button type="primary" @click="excel">导出</Button>
			</Col>
		</Row>
	</Form>
	<p class="totalM mt10">
		参保人员保费合计：{{total}}元
	</p>
	<i-table :columns="columns" url="/trainee/queryPolicyUser" :params="params" ref="table" @on-selection-change="val=>{selectList=val}" selectType="trainee">
		<template slot-scope="scope" slot="isCancel">
			<span>{{scope.row.isCancel?'是':'否'}}</span>
		</template>
		<template slot-scope="{ row,index }" slot="action">
			{{row.isAutoRenew=='1'?'是':'否'}}
		</template>
		<template slot-scope="{ row,index }" slot="action1">
			<!-- 保障中的人和待生效的人可以进行”不再续保“操作 -->
			<a @click="notXubao([row.id])" v-if="row.isAutoRenew&&(row.insuranceStatus=='YUSHOUJIAN'||row.insuranceStatus=='CHENGBAOJIAN')">不再续保</a>
			<Poptip
				transfer
				confirm
				title="是否撤件?"
				@on-ok="withdrawal(row)">
				<a v-if="row.insuranceStatus=='YUSHOUJIAN'">撤件</a>
			</Poptip>
		</template>
	</i-table>
	<Modal
		v-model="selectCompanyShow"
		title="选择参保公司">
		<Form :label-width="100">
			<FormItem label="公司名称">
				<Select v-model="importCompany" clearable >
					<Option :value="item.companyId" v-for="(item,index) in companyInfo.items||[]" v-if="item.ok" :key="index">{{item.companyName}}</Option>
				</Select>
			</FormItem>
			<Alert type="warning" v-if="companyInfo.notOkSize>0">选择框里是已完善信息的参保公司
				<template slot="desc">还有【{{companyInfo.notOkSize}}】家参保公司信息不完善。
					<Button type="success" size="small" @click="toCompany">去完善</Button>
				</template>
			</Alert>
		</Form>
		<div slot="footer">
			<Button type="default" @click="selectCompanyShow=false">取消</Button>
			<Button type="primary" @click="confirmSelectCompany">确定</Button>
		</div>
	</Modal>
</div>
</template>

<script>
import ITable from '@/components/common/ITable'
import daterange from '@/components/common/daterange'

export default {
	components:{daterange,ITable},
	data () {
		return {
			params:{},
			columns:[
				{
					type: 'selection',
					width: 60,
					align: 'center',
					slot: 'action2',
				},
				{title: '保单号',key: 'policyNo',width:160},
				{title: '姓名',key: 'insurantName',width:120},
				{title: '性别',key: 'insurantGenderName',width:65},
				{title: '证件类型',key: 'insurantIdTypeName',width:95},
				{title: '证件号码',key: 'insurantIdNumber',width:190},
				{title: '出生日期',key: 'insurantBirthday',width:120},
				{title: '起保日期',key: 'effectiveDateStart',width:180},
				{title: '终保日期',key: 'effectiveDateEnd',width:180},
				{title: '保费（元）',key: 'premiumAmount',width:110},
				{title: '保障状态',key: 'insuranceStatusName',width:130},
				{title: '结算状态',key: 'endBillStatusName',width:100},
				{title: '参保公司',key: 'companyName',minWidth:200},
				{title: '操作人',key: 'userName',width:100},
				{title: '导入时间',key: 'createTime',width:180},
				// {title: '是否续保',key: 'isAutoRenew',width:100},
				{
					title: '是否续保',
					slot: 'action',
					width: 100,
					align: 'center'
				},
				{title: '取消续保时间',key: 'cancelRenewDate',width:180},
				{
					title: '是否撤件',
					slot: 'isCancel',
					width: 100,
					align: 'center'
				},
				{title: '备注',key:'remarks',width:180},
				{
					title: '操作',
					slot: 'action1',
					width: 120,
					align: 'center',
					fixed:'right'
				}
			],
			total:'',
			importCompany:'',
			selectCompanyShow:false,
			companyInfo:{},
			selectList:[],
			type:0,
		}
	},
	created () {
		this.getTotal();
		this.getCompanyInfo()
	},
	methods: {
		withdrawal(row){
			this.$axios.post("/trainee/userCancel.json",{
				userId:row.id
			}).then(res=>{
				this.toast('操作成功')
				this.search()
			})
		},
		selectChange () {
			if (this.selectList.length==0){
				this.alert('请先勾选要操作的数据')
				return
			}
			let ids = []
			this.selectList.forEach(element => {
				ids.push(element.id)
			});
			this.notXubao(ids)
		},
		// 取消续保
		async notXubao (ids) {
			this.confirm('确认取消续保吗',()=>{
				this.$axios.post("/trainee/cancelAutoRenew.json",ids).then(res=>{
					this.toast('操作成功')
					this.search()
				})
			})
		},
		// 获取总计
		getTotal(){
			this.$axios.post("/trainee/queryPolicyUserPremium",this.params).then(res=>{
				this.total=res
			})
		},
		search() {
			this.$refs.table.getList();
			this.getTotal();
		},
		excel() {
			this.exportToExcel("/trainee/exportPolicyUser",this.params);
		},
		setDateRange (val,key) {
			this.params[key+"Begin"] = val[0];
			this.params[key+"End"] = val[1];
		},
		// 获取公司信息
		getCompanyInfo(){
			this.$axios.post('/trainee/queryCompanyCheckList').then(res=>{
				this.companyInfo=res;
			});
		},
		toImport(val){
			this.type = val
			if(this.companyInfo.notOkSize==this.companyInfo.items.length){
				this.confirm('导入前，请先完善参保公司信息！',()=>{
					this.toCompany()
				},{
					okText:'去完善'
				})
			}else{
				this.selectCompanyShow=true;
				this.importCompany='';
			}
		},
		confirmSelectCompany(){
			this.selectCompanyShow=false;
			// 加nextTick防止未关闭取消overflow:hidden就跳转导致下一页面不能滚动
			this.$nextTick(()=>{
				if (this.type==0)this.$router.push('/trainee-employer/import-person/'+this.importCompany)
				if (this.type==1)this.$router.push('/trainee-employer/import-person-not/'+this.importCompany)
			})
		},
		toCompany(){
			this.selectCompanyShow=false;
			this.$emit('to','Company')
		}
	}
}
</script>
<style scoped lang="less">
.tips{
	font-size: 14px;
	color: red;
	margin-left: 10px;

}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/traineeEmployer/list/Insured.vue